// New Health links store only a provider and ID; measurements remain on the phone.
export function healthLinkPayload(workout) {
  if (["health_connect", "apple_health"].includes(workout?.provider)) return { provider: workout.provider, workoutId: workout.workoutId }
  return workout
}
